import Paho from "paho-mqtt";

/* eslint-disable */
const CameraMqtt = (data, config, id, disconnectedVideo, index) => {
  return new Promise((resolve /* reject */) => {
    let { configuration } = config;
    let client;
    // eslint-disable-next-line
    const sink_topic = data.sink_topic.ipc
      .replace("moto_id", config.moto_id)
      .replace("{device_id}", id);
    const moto_id = config.moto_id;
    const gAgentId = uuid();
    let fromId;
    let isConnected = false;
    let isMqtt = true;
    let iceServers;
    const gSessionId = Math.random().toString(36).substring(7);
    const auth_code = config.auth;
    const pc = new RTCPeerConnection(configuration);

    window.addEventListener(
      "beforeunload",
      () => {
        isMqtt = false;
        sendDisconnect();
      },
      false
    );

    document.querySelector(".header button").addEventListener("click", () => {
      isMqtt = false;
      pc.close();
    });

    connectMqtt()
      .then((/* res */) => {
        setPC()
          .then((me) => {
            resolve(me);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((/* err */) => {
        resolve(false);
      });

    setTimeout(() => {
      resolve(false);
    }, 4000);
    function uuid() {
      // eslint-disable-next-line
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    }

    function connectMqtt() {
      const fromSplit = data.source_topic.ipc.split("/");
      fromId = fromSplit[fromSplit.length - 1];
      const wsbroker = "mqtt.hej.so"; // mqtt websocket enabled broker
      const wsport = 15675; // port for above
      client = new Paho.Client(wsbroker, Number(wsport), "/ws", "", 10);
      return new Promise((resolve, reject) => {
        client.onConnectionLost = function (/* responseObject */) {
          reject();
          if (index !== undefined) disconnectedVideo(index);
        };
        client.onMessageArrived = function (message) {
          let data = JSON.parse(message.payloadString);
          if (isConnected) return;
          if (data.data.header.type === "disconnect") {
            if (index !== undefined) disconnectedVideo(index);
          }
          message.success = true;
          let payload;
          if (data.data.header.type === "answer") {
            payload = data.data.msg.sdp;
          } else if (data.data.header.type === "candidate") {
            // eslint-disable-next-line
            payload = data.data.msg.candidate
              .replace("a=", "")
              .replace("\r\n", "");
          }
          const response = {
            type: data.data.header.type,
            sessionId: data.data.header.sessionid,
            payload,
            success: true,
          };
          parseResponse(response);
        };

        const subscribeOptions = {
          qos: 1,
          onSuccess: (/* e */) => {
            resolve();
          },
          onFailure: (e) => {
            console.log(e);
          },
          timeout: 100,
        };

        const options = {
          timeout: 3,
          keepAliveInterval: 30,
          async onSuccess() {
            const subTopic = data.source_topic.ipc;
            client.subscribe(subTopic, subscribeOptions);
          },
          onFailure(message) {
            parseResponse(message);
            reject();
          },
          userName: "rabbitmqtt",
          password: "rabbitmqtt",
        };
        // options.useSSL = true;
        client.connect(options);
      });
    }

    async function setPC() {
      return new Promise((resolve /* reject */) => {
        (async () => {
          const offerOptions = {
            offerToReceiveAudio: 0,
            offerToReceiveVideo: 1,
          };
          pc.addEventListener("icecandidate", (e) => {
            onIceCandidate(pc, e);
          });
          pc.addEventListener("iceconnectionstatechange", (e) => {
            onIceStateChange(pc, e);
          });
          pc.addEventListener("track", (e) => {
            gotRemoteStream(e).then((res) => {
              resolve(res);
            });
          });
          // pc.addTransceiver('audio', { direction: 'recvonly' });
          pc.addTransceiver("video", { direction: "recvonly" });
          try {
            const offer = await pc.createOffer(offerOptions);
            await onCreateOfferSuccess(offer);
          } catch (e) {
            console.log(e);
          }
        })();
      });
    }

    async function onCreateOfferSuccess(desc) {
      try {
        await pc.setLocalDescription(desc);
      } catch (e) {
        console.log(e);
      }
      sendOffer(desc.sdp);
    }

    async function parseResponse(response) {
      if (response.success !== true) {
        // console.log('response not success');
        return;
      }

      if (response.type === "answer") {
        // console.log('get answer from OpenAPI');
        const answer = {
          type: "answer",
          sdp: response.payload,
        };
        // answer["type"] = "answer";
        // answer["sdp"] = response.payload;
        pc.setRemoteDescription(answer)
          .then()
          .catch((/* err */) => {
            if (index !== undefined) disconnectedVideo(index);
          });
      } else if (response.type === "candidate") {
        // var candidate = {};
        // candidate["candidate"] = response.payload;
        // candidate["sdpMid"] = "0";
        // candidate["sdpMLineIndex"] = 0;
        const candidate = {
          candidate: response.payload,
          sdpMid: "0",
          sdpMLineIndex: 0,
        };
        pc.addIceCandidate(candidate).catch((e) => {
          console.log(e);
          // console.log('addIceCandidate fail: ' + e.name);
          if (index !== undefined) disconnectedVideo(index);
        });
      } else if (response.type === "disconnect") {
        if (index !== undefined) disconnectedVideo(index);
        sendDisconnect();
      } else if (response.type === "webrtcConfigs") {
        // console.log('get iceServers from OpenAPI');
        iceServers = JSON.parse(response.payload);
        configuration = {
          iceServers: iceServers,
        };
        setPC();
      }
    }

    async function sendDisconnect() {
      try {
        sendWS("disconnect", "");
      } catch (e) {
        console.log("hangup the call fail: " + e.name);
      }
      pc.close();
    }

    function sendWS(type, payload) {
      let message = {
        mode: "webrtc",
      };
      if (type === "offer") {
        message.sdp = payload;
        message.stream_type = 1;
        message.auth = auth_code;
      } else if (type === "candidate") {
        message.candidate = payload;
      }
      if (isMqtt) {
        const requestData = {
          protocol: 302,
          pv: "2.2",
          t: parseInt((new Date().getTime() / 1000).toFixed(0)),
          data: {
            header: {
              type: type,
              from: fromId,
              to: id,
              sub_dev_id: "",
              sessionid: gSessionId,
              moto_id: moto_id,
            },
            msg: message,
          },
          source_topic: data.source_topic.ipc,
          sink_topic: sink_topic,
          userName: data.username,
          password: data.password,
          client_id: data.client_id,
        };
        const msg = JSON.stringify(requestData);
        message = new Paho.Message(msg);
        message.destinationName = "mqtt.goqual.io";
        message.qos = 1;
        client.send(message);
      } else {
        const sendData = {};
        sendData.agentId = gAgentId;
        sendData.sessionId = gSessionId;
        sendData.type = type;
        sendData.payload = payload;
      }
    }

    async function sendOffer(sdp) {
      // shorter sdp, remove a=extmap... line, device ONLY allow 8KB json payload
      // eslint-disable-next-line
      sdp = sdp.replace(/\r\na=extmap[^\r\n]*/g, "");
      try {
        sendWS("offer", sdp);
      } catch (e) {
        // console.log(e);
        // console.log('send offer via WebSocket fail: ' + e.name);
      }
    }

    async function sendCandidate(candidate) {
      try {
        sendWS("candidate", candidate);
      } catch (e) {
        // console.log(e);
        // console.log('sendCandidate fail: ' + e.name);
      }
    }

    async function onIceCandidate(pc, event) {
      // console.log(`ICE candidate:\n${event.candidate ? event.candidate.candidate : '(null)'}`);
      // console.log('check : ', event.candidate);
      try {
        if (event.candidate != null) {
          sendCandidate(`a=${event.candidate.candidate}`);
        } else {
          // sendCandidate('');
        }
      } catch (e) {
        onAddIceCandidateError(pc, e);
      }
    }

    function onAddIceCandidateError(pc, error) {
      console.log(`failed to add ICE Candidate: ${error.toString()}`);
    }

    function onIceStateChange(pc /* event */) {
      if (pc) {
        if (pc.iceConnectionState === "connected") {
          // console.log('webRTC connected');
          isConnected = true;
        } else if (pc.iceConnectionState === "disconnected") {
          if (index !== undefined) {
            disconnectedVideo(index);
          }
        }
      }
    }
  });

  function gotRemoteStream(e) {
    return new Promise((resolve /* reject */) => {
      if (e && e.track.kind === "video") {
        if (document.getElementById(`cctv-video-${index}`)) {
          document.getElementById(`cctv-video-${index}`).srcObject =
            e.streams[0];
        }
        resolve(e.streams[0]);
      }
    });
  }
};

export default CameraMqtt;
